import { Icon, Stack } from "@fluentui/react";

import { Contract } from "../../contract.interface";
import { ContractInfoCamp } from "../ClientInfo";
import { DefaultCardTitle } from "../styles";

import { Card } from "@/components/Shared/Card";
import {
  TranslatedContractOrigin,
  TranslatedSignatureType
} from "@/modules/Contracts/enums";
import { formatDateAndTimeToString } from "@/utils/FormatDate";
import { toLocaleString } from "@/utils/ToLocaleString";

interface ContractInfoProps {
  contract: Contract;
  title: string;
  isInsidePanel: boolean;
}

const tokens = {
  sectionStack: {
    childrenGap: 10,
    padding: 20
  },
  headingStack: {
    childrenGap: 10
  }
};

export function ContractInfo({
  contract,
  title,
  isInsidePanel
}: ContractInfoProps): JSX.Element {
  const createdAtDate = new Date(contract.createdAt);
  const updatedAtDate = new Date(contract.updatedAt);

  const buParent = contract.businessUnit?.parent;
  const names = [
    buParent?.parent?.name,
    buParent?.name,
    contract.businessUnit.name
  ].filter(Boolean);
  const buName = names.join(" -> ");

  return (
    <Stack verticalFill>
      <Stack
        horizontal
        className="ms-sm12"
        style={{ marginBottom: "1vh", height: 35 }}
      >
        <DefaultCardTitle>
          <Icon iconName="ClipboardList" style={{ marginRight: 10 }} />
          {title}
        </DefaultCardTitle>
      </Stack>

      <Card borderRadius="1rem" padding="1rem">
        <Stack horizontal wrap tokens={tokens.sectionStack}>
          <Stack.Item
            grow
            className={`ms-sm12 ${!isInsidePanel ? "ms-lg5" : ""}`}
          >
            <Stack tokens={tokens.headingStack}>
              <ContractInfoCamp
                title={"Tipo de Assinatura:"}
                value={TranslatedSignatureType[contract?.signature?.type]}
              />
              <ContractInfoCamp title={"Empresa:"} value={buName} />
              <ContractInfoCamp
                title={"Autor do Contrato:"}
                value={contract.user.fullName}
              />
              {contract.user.businessUnit?.name && (
                <ContractInfoCamp
                  title={"Unidade de Negócio do Autor:"}
                  value={contract.user.businessUnit?.name}
                />
              )}
              <ContractInfoCamp
                title={"Criado em:"}
                value={formatDateAndTimeToString(createdAtDate)}
                data-clarity-unmask
              />
              <ContractInfoCamp
                title={"Atualizado em:"}
                value={formatDateAndTimeToString(updatedAtDate)}
                data-clarity-unmask
              />
            </Stack>
          </Stack.Item>

          <Stack.Item
            grow
            className={`ms-sm12 ${!isInsidePanel ? "ms-lg5" : ""}`}
          >
            <Stack tokens={tokens.headingStack}>
              <ContractInfoCamp
                title={"Categoria:"}
                value={contract.serviceCategory.name}
              />
              <ContractInfoCamp
                title={"Benefício prestado:"}
                value={contract.service.name}
              />
              {contract?.setupPaymentMethod?.name && (
                <ContractInfoCamp
                  title={"Método de Pagamento da Adesão:"}
                  value={contract.setupPaymentMethod.name}
                />
              )}
              <ContractInfoCamp
                title={"Entrega:"}
                value={
                  contract.shipping
                    ? `
                      Frete
                      ${contract.shipping?.name}
                      - Prazo de entrega
                      ${contract.shipping?.deliveryTime}
                      ${contract.shipping?.deliveryTime > 1 ? "dias" : "dia"}
                      - Valor
                      ${toLocaleString(contract.shipping?.price)}`
                    : "Não foram encontrados dados sobre a entrega."
                }
              />
              <ContractInfoCamp
                title={"Time comercial:"}
                value={
                  contract.salesTeam?.name
                    ? `${contract.salesTeam?.name}`
                    : " — "
                }
              />

              <ContractInfoCamp
                title={"Origem:"}
                value={TranslatedContractOrigin[contract.origin]}
              />
            </Stack>
          </Stack.Item>
        </Stack>
      </Card>
    </Stack>
  );
}
